import { CURRENT_AVAILABLE_GROUPS, useAuthContext, useHasAuthGroup } from 'providers/auth';

/**
 * Whether the notification bell and the activity feed behind it are reachable for this user. Used by
 * both, so they can't be gated apart.
 *
 * A call-center rep's route tree is the conversations view alone, so every event the feed carries
 * would name something they can't open. Negates router.tsx's `!isInternal && isCallCenterRep` — the
 * branch that hands them that tree — so the two can't drift.
 */
export const useOutreachActivityVisible = (): boolean => {
  const { isInternal } = useAuthContext();
  const isCallCenterRep = useHasAuthGroup(CURRENT_AVAILABLE_GROUPS.CustomerCallCenterRep);
  return isInternal || !isCallCenterRep;
};
